import { logger as LOG } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Attempts to create a URL instance from the provided string.
 * If the string is not a valid URL, it logs the error and returns null.
 */
export function safelyGetUrlInstance(url: string) {
  try {
    return new URL(url);
  } catch (error: unknown) {
    logger.error(error);

    return null;
  }
}

// ─── Logger ──────────────────────────────────────────────────────────────────

export const logger = LOG.extend('Cookies');
LOG.disable('Cookies');
